import React from 'react'

const CircleHomeHref = props => {
    const circleStyle ={
        borderRadius:"250px",
        display:"flex",
        justifyContent:"center",
        alingItems:"center",
        flexDirection:"column",
        maxWidth:"180px",
        textAlign:"center",
        Gap: "60px"
    }
    return (
        <div className="text-center" style={circleStyle}>
            <a className="circle-best" href={props.link ? props.link : ""} target={props.target}>
            <img style={{width:"100px"}} src={props.img} alt=""/>
            <p style={{fontSize:"16px", textDecoration:"none", marginTop:"16px", color:"#8f8b0c"}} dangerouslySetInnerHTML={{__html:props.text}}></p>
            
            </a>
        </div>
    )
}

export default CircleHomeHref